<div class="merch-market website" infinite-scroll [infiniteScrollDistance]="0.1" [infiniteScrollDisabled]="entredapi"
    [scrollWindow]="true" (scrolled)="onScrollDown()">
    <div class="mt-100 marketPlaceSection">
        <div class="">
            <div class="privacy-box">
                <div class="nft-lists-comp">
                    <div class="filterheader">
                        <h2>Explore the MarketPlace</h2>
                        <div class="overbtns">
                            <i class="fa fa-angle-left arrows" (click)="scrollheader('left')"></i>
                            <i class="fa fa-angle-right arrows" (click)="scrollheader('right')"></i>
                            <div class="categorybtns" id="categoryBtns">
                                <div class="pl-0 pr-0" *ngFor="let category of categoryList">
                                    <button class="btn1" [ngClass]="{'bt2' : category.fillter}"
                                        (click)='getFilter(category,"category")'><a>{{category.value}}</a></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters mt-3 mb-3 align-items-center">
                        <div class="col-lg-4 col-sm-12 col-xs-12 col-md-12">
                            <div class="d-flex align-items-center ">

                                <div class="relative w-100">
                                    <input [(ngModel)]="query" placeholder="Search Collections by name"
                                        (input)="getFilterData('search')" class="custom-field w-100">
                                    <i class="fa fa-search"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-8 text-right">
                            <!-- <div class="text-right d-inline-block mr-2">
                                <span class="dropdown" id="DD">
                                    <div mat-flat-button class=" btn btn-primary dropdown-toggle"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <div class="row">
                                            <div class="col-1">
                                                <i class="material-icons">filter_list</i>
                                            </div>
                                            <div class="col-10">
                                                <span class="text-truncate d-inline-block mt-1">Filter</span>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="dropdown-menu w-313" id="getingFilter"
                                        aria-labelledby="dropdownMenuButton">
                                        <div class="relative">
                                            <div class="inner-dropdown p-15">
                                                <i class="fa fa-times-circle-o closeicon pointer"
                                                    (click)="closeFilter()"></i>
                                                <div class="row no-gutters align-items-center mb-2 mt-1">
                                                    <div class="fs-16  col-6" *ngIf="price.length>0"> Price</div>
                                                    <div class="fs-16 text-right col-6" *ngIf="price.length>0"> <span
                                                            class="pointer fs-16" (click)="cleraFilter('price')"
                                                            *ngIf="priceClear">Clear</span>
                                                    </div>
                                                </div>
                                                <div class="row no-gutters" *ngIf="price.length>0">
                                                    <div class="col-5">
                                                        <div class="inpflex">
                                                            <span class="symbol fs-14">{{getCurrency |
                                                                currencySymbol}}</span>
                                                            <input type="text" mat-input class="w-100 textbox"
                                                                placeholder="Minimum" [(ngModel)]="mininput" allowValues
                                                                isInputType="number" (input)="priceValues('min')">
                                                        </div>
                                                        <div class="error" *ngIf="minerror"> {{minmessage}}</div>

                                                    </div>
                                                    <div class="col-5">
                                                        <div class="inpflex">
                                                            <span class="symbol fs-14">{{getCurrency |
                                                                currencySymbol}}</span>
                                                            <input type="text" mat-input class="w-100 textbox"
                                                                placeholder="Maximum" [(ngModel)]="maxinput" allowValues
                                                                isInputType="number" (input)="priceValues('max')">
                                                        </div>
                                                        <div class="error" *ngIf="maxerror"> {{maxmessage}}</div>
                                                    </div>
                                                    <div class="col-2">
                                                        <button class="dropdown-item applynow pointer"
                                                            (click)="priceValues('price')"
                                                            [hidden]="mininput.length == 0 && maxinput.length == 0 ">Go</button>
                                                    </div>
                                                </div>
                                                <ng-container *ngFor="let filterhead of overallFilter">

                                                    <div class="row no-gutters align-items-center mb-2 mt-3">
                                                        <div class="fs-16 col-6">{{filterhead.name | titlecase }}
                                                        </div>
                                                        <div class="col-6 text-right"><span class="pointer fs-16"
                                                                (click)="cleraFilter(filterhead.name)"
                                                                *ngIf="filterhead.showfilter">Clear</span>
                                                        </div>
                                                    </div>
                                                    <div class="row no-gutters" *ngIf="filterhead.name != 'discount'">
                                                        <ng-container *ngFor="let filter of filterhead.value.buckets">
                                                            <div class="col-4 p-l-r-5">
                                                                <button class="filterbtn mb-2"
                                                                    matTooltipPosition="above"
                                                                    matTooltip="{{filter.value}}"
                                                                    [ngClass]="{'filterbtnactive' : filter.fillter }"
                                                                    (click)='getFilter(filter,"filter",filterhead.name)'>
                                                                    <span *ngIf="filter.value == 1.0 ">Yes</span>
                                                                    <span *ngIf="filter.value == 0.0">No</span>
                                                                    <span
                                                                        *ngIf="filter.value != 0.0 && filter.value != 1.0 ">{{filter.value}}</span></button>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                    <div class="row no-gutters" *ngIf="filterhead.name == 'discount'">
                                                        <ng-container *ngFor="let filter of filterhead.value.buckets">
                                                            <div class="col-6 p-l-r-5">
                                                                <button class="filterbtn mb-2"
                                                                    matTooltipPosition="above"
                                                                    matTooltip="{{filter.value == 1.0?'Yes':'No'}}"
                                                                    [ngClass]="{'filterbtnactive' : filter.fillter }"
                                                                    (click)='getFilter(filter,"filter",filterhead.name)'>
                                                                    <span *ngIf="filter.value == 1.0 ">Yes</span>
                                                                    <span *ngIf="filter.value == 0.0">No</span>
                                                                </button>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>

                                                <div class="fs-16 mt-1">Stock</div>
                                                <button class="dropdown-item  pointer mt-2 mb-3" id="stockButton"
                                                    [ngClass]="stockData.value == 0?'clearAll' : 'applynow' "
                                                    (click)="getstock()">
                                                    Exclude Unavailable stock</button>
                                            </div>
                                            <div class=" text-center p-15">

                                                <div class="dropdown-item clearAll pointer"
                                                    (click)="applyfilter('cancel')">Clear All</div>


                                            </div>
                                        </div>

                                    </div>
                                </span>
                            </div> -->
                            <div class="text-right d-inline-block">
                                <span class="dropdown">
                                    <div mat-flat-button class=" btn btn-primary dropdown-toggle"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <div class="row">
                                            <div class="col-1">
                                                <i class="material-icons">sort</i>
                                            </div>
                                            <div class="col-10">
                                                <span class="text-truncate d-inline-block mt-1">{{sortName == ''?'Sort
                                                    By':sortName}}</span>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <span>
                                            <ng-container *ngFor="let sort of sortBy">
                                                <a class="dropdown-item fs-13"
                                                    (click)="sortbyfilter(sort.value,sort.name)">{{sort.name}}</a>
                                            </ng-container>
                                        </span>


                                    </div>
                                </span>
                            </div>
                        </div>

                    </div>

                    <section class="card-Sec pointer" *ngIf="brandProductsList.length > 0">
                        <div class="cards-con">
                            <ng-container *ngFor="let brand of brandProductsList">
                                <div class="cards" (click)="getProduct(brand._source.collection_id,brand._source.organization_id, brand._source.channel_name,brand._source?.network_group_id, brand._source?.group_slug)">
                                    <div class="imagediv"
                                        [ngStyle]="{'background-image':' url(' + brand?._source?.images + ')'}">

                                        <div class="pro-img" *ngIf="brand._source.logo != 'NA'"
                                            [ngStyle]="{'background-image':' url(' + brand?._source?.logo + ')'}">
                                        </div>
                                        <div class="pro-img" *ngIf="brand._source.logo == 'NA'"
                                            [ngStyle]="{'background-image':' url(' + brand?._source?.images + ')'}">
                                        </div>
                                    </div>
                                    <div class="desc-con">
                                        <div class="desc-h mt-2" matTooltipPosition="above"
                                            matTooltip="{{brand?._source?.title}}">{{brand._source.title}}
                                        </div>
                                        <div class="dec mt-2" matTooltipPosition="above"
                                            matTooltip="{{brand?._source?.description}}">
                                            {{brand._source.description}}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </section>
                    <div class="d-flex justify-content-center align-items-center no-data-available" *ngIf="brandProductsList.length == 0" >
                        NO DATA AVAILABLE
                    </div>
                    <div class="scroll-text " *ngIf="found != brandProductsList.length"> Scroll down for more
                    </div>
                    <!-- <div *ngIf="found == brandProductsList.length && brandProductsList.length!=0 ">
                        <div class="d-flex align-items-center justify-content-center mt-25">
                            <span class="leftend"></span>
                            <span class="end">END</span>
                            <span class="rightend"></span>
                        </div>
                    </div> -->


                </div>

            </div>
        </div>


    </div>

    <!-- <div>
        <app-svg [icon]="'data-not-found'"></app-svg>
    </div> -->
</div>